import { Autocomplete, AutocompleteProps } from "@mui/material";

export function StyledAutocomplete<
  T,
  Multiple extends boolean | undefined,
  DisableClearable extends boolean | undefined,
  FreeSolo extends boolean | undefined,
>(props: AutocompleteProps<T, Multiple, DisableClearable, FreeSolo>) {
  return (
    <Autocomplete<T, Multiple, DisableClearable, FreeSolo>
      {...props}
      sx={{
        ...props.sx,
        fontSize: "0.6rem",
      }}
    />
  );
}

export default StyledAutocomplete;
